import { Navigate } from "react-router-dom";
import { SubLayout } from "../components";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";

interface Props {
  children: JSX.Element | JSX.Element[];
  allowedRoles: number[];
}

export const RoleProtectedRoute = ({ children, allowedRoles }: Props) => {
  const { validateToken, idRole } = useContext(AuthContext);

  if (!validateToken()) {
    return <Navigate to="/" replace />;
  }

  if (idRole === null || !allowedRoles.includes(idRole)) {
    return <Navigate to={idRole === 3 ? "/proposal" : "/home"} replace />;
  }

  return <SubLayout>{children}</SubLayout>;
};
